/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Loader from '../loader';

class Deferrer extends Component {
  constructor() {
    super();
    this.state = {
      loaded: false
    };
  }

  handleLoad = () => {
    this.setState({ loaded: true });
    window.removeEventListener('load', this.handleLoad);
  };

  componentDidMount() {
    window.addEventListener('load', this.handleLoad);
    window.setTimeout(this.handleLoad, 5000);
  }

  componentDidUpdate() {
    const { loaded } = this.state;
    if (!loaded) this.handleLoad();
  }

  componentWillUnmount() {
    window.removeEventListener('load', this.handleLoad);
  }

  render() {
    const { loaded } = this.state;
    const { children } = this.props;
    return loaded ? (
      children
    ) : (
      <Loader {...this.props} isLoading>
        <div {...this.props}>Loading...</div>
      </Loader>
    );
  }
}

Deferrer.propTypes = {
  children: PropTypes.node.isRequired
};

export default Deferrer;
